export const DEFAULT_IMAGES = {
  PORTRAIT: '/static/images/default_editorial_portrait.png',
  LANDSCAPE: '/static/images/default_editorial_landscape.png'
};
